import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from "@ng-select/ng-select";
import { AiQuestions } from './aiQuestions';
import { AiQuestionsRoutingModule } from "./aiQuestions-routing.module";
import { TableModule } from "../generic/table/table.module";
import { AiService } from "../../../service/AiService";
import { AiConfigService } from "../../../service/AiConfigService";
import { CourseService } from "../../../service/CourseService";
import { QuestionService } from "../../../service/QuestionService";
import { LibraryService } from "../../../service/LibraryService";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    TableModule,
    AiQuestionsRoutingModule
  ],
  providers: [AiService, AiConfigService, CourseService, QuestionService, LibraryService],
  exports: [AiQuestions],
  declarations: [AiQuestions]
})
export class AiQuestionsModule {}
